export default __webpack_public_path__ + "static/media/403.81e74af4.svg";